<template>
  <div class="provider-search">
    <h4 class="mb-2 grey--text" v-if="searchResults.length">Search results for &ldquo;{{ searchTerm }}&rdquo;:</h4>

    <ul v-if="searchResults.length" class="list--unstyled mb-3">
      <li v-for="provider in searchResults">
        <add-provider-link
          :provider="provider"
          :service-types="serviceTypesForAdd"
          :decoration="false"
          class="blue--text text--accent-1"
        />
      </li>
    </ul>

    <h4 v-else class="provider-search__noresults mb-2 grey--text text--lighten-3">
      Your search for <strong>&ldquo;{{ searchTerm }}&rdquo;</strong> didn&rsquo;t return any results.
    </h4>

    <h4 class="mb-2 grey--text">
      Don&rsquo;t see your {{ serviceType ? serviceType.name : '' }} provider?
      <a role="button" href="/addbiller" class="white--text">Add them!</a>
    </h4>
  </div>
</template>

<script>
  import AddProviderLink from '@/components/common/AddProviderLink'

  export default {
    computed: {
      serviceTypesForAdd () {
        return this.serviceType ? [this.serviceType] : []
      }
    },
    props: ['searchTerm', 'searchResults', 'serviceType'],
    components: {
      AddProviderLink
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/ProviderSearchResults.vue